"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.chartCreator = void 0;
const Plot = __importStar(require("@observablehq/plot"));
const viem_1 = require("viem");
const chartCreator = (chartRef, rows, clearChart, recentDeposits) => {
    if (!chartRef?.current) {
        return;
    }
    const width = chartRef.current.clientWidth;
    const height = 440;
    const chart = Plot.plot({
        width: Math.min(width, 900),
        height,
        marginLeft: 70,
        marginRight: 50,
        marginBottom: 60,
        style: {
            background: "inherit",
        },
        y: {
            axis: "left",
            grid: true,
            label: "Count",
            nice: true,
            line: true,
            labelAnchor: "top",
            labelOffset: 40,
            transform: (d) => Number(d || 0),
        },
        x: {
            label: "Date",
            type: "band",
            line: true,
            nice: true,
            labelAnchor: "center",
            transform: (d) => new Date(d),
            labelOffset: 60,
            tickRotate: -45,
            tickFormat: "%m/%d",
        },
        marks: [
            Plot.barY(rows, {
                y: recentDeposits ? "new_deposit_count" : "current_deposit_count",
                x: "start_date",
                fill: "#ccc",
            }),
            () => Plot.plot({
                width: Math.min(width, 900),
                height,
                marginLeft: 70,
                marginRight: 50,
                marginBottom: 60,
                style: {
                    background: "inherit",
                },
                x: {
                    type: "band",
                    axis: null,
                    nice: true,
                    transform: (d) => new Date(d),
                },
                y: {
                    axis: "right",
                    label: "Amount",
                    line: true,
                    nice: true,
                    transform: (d) => (d ? Number((0, viem_1.formatUnits)(BigInt(d), 18)) : 0),
                    tickFormat: (d) => `Ξ ${d}`,
                },
                marks: [
                    Plot.line(rows, {
                        y: recentDeposits ? "new_deposit_amount" : "current_deposit_amount",
                        x: "start_date",
                        curve: "catmull-rom",
                        marker: "circle",
                    }),
                ],
                color: {
                    scheme: "blues",
                },
            }),
        ],
        color: {
            scheme: "blues",
        },
    });
    clearChart();
    chartRef.current.append(chart);
};
exports.chartCreator = chartCreator;
//# sourceMappingURL=chart-creator.js.map